import React, { ReactElement, useRef } from "react";
import { createPortal } from "react-dom";

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactElement;
}

const ActionSheet: React.FC<IProps> = ({ visible, setVisible, children }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setVisible(false);
    }
  };

  return (
    visible &&
    createPortal(
      <div className="w-screen h-screen bg-#1F2533 bg-op-36 left-0 right-0 mobile-page" onClick={handleClickOutside}>
        <div ref={ref}>{children}</div>
      </div>,
      document.getElementById("root") as HTMLElement
    )
  );
};

export default ActionSheet;
